// 其它
export default [
	{
		path: '/landing',
		name: 'landing',
		component: () => import('@/views/other/landing.vue'),
		meta: { title: '加载中...' }
	},
	{
		path: '/other/tools',
		name: 'tools',
		component: () => import('@/views/other/tool.vue'),
		meta: { title: '数据展示' }
	},
	{
		path: '/guide',
		name: 'guide',
		component: () => import('@/views/other/guide.vue'),
		meta: { title: '使用指南' }
	}
]
